import { render } from "./AnnouncementDescription.vue?vue&type=template&id=ba5a27d0&scoped=true"
import script from "./AnnouncementDescription.vue?vue&type=script&lang=js"
export * from "./AnnouncementDescription.vue?vue&type=script&lang=js"

import "./AnnouncementDescription.vue?vue&type=style&index=0&id=ba5a27d0&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba5a27d0"]])

export default __exports__